import server from "./server";

export const getNotificationsApi = async () => {
  const response = await server().get("/notifications");
  return response.data;
};
